/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
 */
export interface GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule {
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'rate': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'merchantCategoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'merchantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'binSponsor'?: GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleBinSponsorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'creditOrPrepaid'?: GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleCreditOrPrepaidEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'minimumTotalAmount': number;
}

export const GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleBinSponsorEnum = {
    lc: 'LC',
    cs: 'CS'
} as const;

export type GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleBinSponsorEnum = typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleBinSponsorEnum[keyof typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleBinSponsorEnum];
export const GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleCreditOrPrepaidEnum = {
    credit: 'CREDIT',
    prepaid: 'PREPAID'
} as const;

export type GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleCreditOrPrepaidEnum = typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleCreditOrPrepaidEnum[keyof typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleCreditOrPrepaidEnum];


